<section id="request-demo-hero">
  <div id="request-demo-hero-copy">
    <span class="x-large-font font-white">Request a demo</span>
    <h3 class="font-white">
      Want to learn more about MedShorts & what we do for pharmacies &
      manufacturers?
    </h3>
  </div>
</section>

<div class="container-fluid section-2 py-4 mt-4">
  <div class="row mt-4">
    <div class="col-md-12">
      <div style="max-width: 800px; margin: 0 auto">
        <app-static-footer></app-static-footer>
      </div>
    </div>
  </div>
</div>
